import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import Modal from "react-modal";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from 'react-toastify';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "100%" : '55%'
  },
};


export default function EditSalah({
    editSalahInfo,
    setEdit,
    edit,
}) {
    const [salahEditInfo, setSalahEditInfo] = useState({});

    useEffect(() => setSalahEditInfo(editSalahInfo), []);

    const salahEdit = async (e) => {
        e.preventDefault();
        try {
            const salahInserted = await axios.put(
              `https://ahlehaqserver.herokuapp.com/api/salah/${editSalahInfo._id}`,
              salahEditInfo
            );
    
            //if request success, will show success notification
            if (salahInserted.data.code === 200) {
                
              setEdit(false)
              toast.success("Salah edited successfully!");
              e.target.reset();
            }
        } catch (error) {
          console.log(error);
          toast.error("Internal Server Error!");
        }
      };
    return (
        <>
         <Modal isOpen={edit} style={customStyles}>
          <h1 className="ml-3">Edit Salah</h1>
              
              <form onSubmit={salahEdit}>
                       <div className="row">
                         
 
                         <div className="col-md-6">
                           <div className="form-group">
                             <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                             Salah Title<span className="text-danger">*</span>
                             </label>
                             <input
                               type="text"
                               className="form-control rounded"
                               placeholder="write salah title"
                               id="exampleInputPassword1"
                               name="title"
                               value={salahEditInfo?.title || ""}
                               required
                               onChange={(e) =>
                                setSalahEditInfo((prev) => ({
                                   ...prev,
                                   [e.target.name]: e.target.value,
                                 }))
                               }
                             />
                           </div>
                          </div>
 
                          <div className="col-md-6">
                           <div className="form-group">
                             <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                             Write Pdf Url<span className="text-danger">*</span>
                             </label>
                             <input
                               type="text"
                               className="form-control rounded"
                               placeholder="https://something.pdfUrl"
                               id="exampleInputPassword1"
                               name="pdfUrl"
                               value={salahEditInfo?.pdfUrl || ""}
                               required
                               onChange={(e) =>
                                 setSalahEditInfo((prev) => ({
                                   ...prev,
                                   [e.target.name]: e.target.value,
                                 }))
                               }
                             />
                           </div>
                          </div>
                           
                          <div className="col-md-6">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 "
                              >
                                Done
                              </button>
                              <button
                                className="btn btn-danger rounded-pill px-4 ml-3"
                                onClick={() => setEdit(false)}
                                >
                                Close
                                </button>
                            </div>  
                         </div> 
 
                       </div>
 
                       
                     </form>   
            </Modal>       
        </>
    )
}
